import HttpFactory from '../HttpFactory'
import type IBasicArrayResponse from '../interfaces/IBasicArrayResponse'
import type IBasicObjectResponse from '../interfaces/IBasicObjectResponse'
import type { CurrentPortalDataDTO } from '~/types/TypesFromPortalBackend'

class PortalsModule extends HttpFactory {
  private RESOURCE = 'api/portals'

  async getAllPortals () {
    return await this.callUseAsyncData<IBasicArrayResponse>(
      'GET',
      `${this.RESOURCE}`
    )
  }

  async getCurrentPortal () {
    return await this.callUseAsyncData<IBasicObjectResponse<CurrentPortalDataDTO>>(
      'GET',
      `${this.RESOURCE}/current`
    )
  }

  async getPortalById (portalId: string) {
    return await this.callUseAsyncData<IBasicObjectResponse>(
      'GET',
      `${this.RESOURCE}/${portalId}`
    )
  }
}

export default PortalsModule
